import {ProjectListItem} from '../../../modules/apps/project/core/_models'

export const parseHomeDataToTable = (listData: Array<ProjectListItem>, sort: {Sort: string, Order: 'desc' | 'asc'} = {Sort: 'LastModificationDate', Order: 'asc'}) => {
  // const sort = {...sortB, Order: (sortB?.Sort === 'LastModificationDate' && sortB?.Order === 'asc' ? 'desc' : (sortB?.Sort === 'LastModificationDate' && sortB?.Order === 'desc' ? 'asc' : sortB?.Order))}
  const data: Array<{
    columns: Array<{
      colIndex: number
      value: any
      type: 'text' | 'date' | 'integer' | 'decimal' | 'percent' | 'action'
      rowIndex: number
      dataKey: string
      rowGuid: string
      content?: any
    }>
    rowType: 'data' | 'header'
    rowIndex: number
    rowGuid: string
  }> = []
  const theL = [...listData]
  theL.sort((a: any, b: any) => {
    if (sort.Order === 'asc' && a[sort.Sort] >  b[sort.Sort]) {
      return -1
    } else if (sort.Order === 'asc' && a[sort.Sort] <  b[sort.Sort]) {
      return 1
    } else if (sort.Order === 'desc' && a[sort.Sort] >  b[sort.Sort]) {
      return 1
    } else if (sort.Order === 'desc' && a[sort.Sort] <  b[sort.Sort]) {
      return -1
    }
    return 0
  })
  theL.forEach((v, i) => {
    const aRow: {
      columns: Array<{
        colIndex: number
        value: any
        type: 'text' | 'date' | 'integer' | 'decimal' | 'percent' | 'action'
        rowIndex: number
        dataKey: string
        rowGuid: string
        content?: any
      }>
      rowType: 'data' | 'header'
      rowIndex: number
      rowGuid: string
    } = {
      columns: [
        {
          colIndex: 0,
          dataKey: 'LastModificationDate',
          rowGuid: v.Guid,
          rowIndex: i+1,
          type: 'text',
          value: '',
          content: {
            LastModificationPerson: {
              className: 'fw-bolder fs-4 text-gray-700',
              type: 'text',
              value: v.LastModificationPerson
            },
            LastModificationDate: {
              className: 'fs-5 text-muted',
              type: 'date',
              value: v.LastModificationDate
            }
          }
        },
        {
          colIndex: 0,
          dataKey: 'CompanyName',
          rowGuid: v.Guid,
          rowIndex: i+1,
          type: 'text',
          value: '',
          content: {
            ProjectTitle: {
              className: 'fw-bolder fs-4  text-gray-700',
              type: 'text',
              value: v.ProjectTitle
            },
            CompanyName: {
              className: 'fs-5 text-muted',
              type: 'text',
              value: v.CompanyName
            }
          }
        },
        {
          colIndex: 0,
          dataKey: 'Status',
          rowGuid: v.Guid,
          rowIndex: i+1,
          type: 'text',
          value: v.Status
        },
        {
          colIndex: 0,
          dataKey: 'ProgressPercentage',
          rowGuid: v.Guid,
          rowIndex: i+1,
          type: 'percent',
          value: v.ProgressPercentage
        },
        {
          colIndex: 0,
          dataKey: 'ProgressPercentage',
          rowGuid: v.Guid,
          rowIndex: i+1,
          type: 'action',
          value: '',
        },
      ],
      rowGuid: v.Guid,
      rowIndex: i+1,
      rowType: 'data',
    }
    data.push(aRow)
  })
  // data.sort((a, b) => {
  //   if (a.)
  // })
  return data
}
